import { StringUnion } from '@shared-lib/utils/string-union';

export const PAYMENT_MODAL_TYPE = StringUnion('ticket', 'paymentRequest', 'userPoint');
export type PaymentModalType = typeof PAYMENT_MODAL_TYPE.type;
